/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createApi } from '@reduxjs/toolkit/query/react';

import { JimboResponse, WebhookEndpoints } from '@models';
import { baseQueryWithReauth } from '@services/refreshToken.service';

export const webhookApi = createApi({
  reducerPath: 'webhookApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['webhook'],
  endpoints: (builder) => ({
    getWebhook: builder.query<WebhookEndpoints[], void>({
      query: () => `/webhook`,
      providesTags: ['webhook'],
      transformResponse: (response: JimboResponse<WebhookEndpoints[]>) => response.data!,
    }),
    createWebhook: builder.mutation<WebhookEndpoints, Partial<WebhookEndpoints>>({
      query: (webhook) => ({
        url: '/webhook',
        method: 'POST',
        body: webhook,
      }),
      transformResponse: (response: JimboResponse<WebhookEndpoints>) => response.data!,
      invalidatesTags: ['webhook'],
    }),

    deleteWebhook: builder.mutation<JimboResponse, string>({
      query: (webhookId) => ({
        url: `webhook/${webhookId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['webhook'],
    }),
  }),
});

export const { useGetWebhookQuery, useCreateWebhookMutation, useDeleteWebhookMutation } = webhookApi;
